export enum DrawStatus {
	Noten,
	Tenpai,
	Nagashi_Mangan
}
